import { Field, getIn, useFormikContext } from "formik";
import React, { FC } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { validateRssiField } from "../../utilities/Validation";
import CheckboxField from "../checkbox-list-field/checkboxField";
import Label from "../label/label";
import Togglebox from "../togglebox/togglebox";

const HIDPresetMobileTab: FC = () => {
    const { setFieldValue, errors, values } = useFormikContext<any>();
    const { translate } = useLocale();

    //Used to access the value and errors for deeply nest objects within a Field.
    const tapRssiError = getIn(errors, 'mobileValues.hidMobileValues.tapRssi');
    const twistAndGoRssiError = getIn(errors, 'mobileValues.hidMobileValues.twistAndGoRssi');
    const remoteRssiError = getIn(errors, 'mobileValues.hidMobileValues.remoteRssi');

    return <div className="w-full h-full overflow-y-auto pb-10">
        <div className="flex flex-col py-3">
            <Label
                htmlFor="mobileValues.hidMobileValues.enabled"
                className="text-sm pt-1">{translate.byKey(TranslationKeys.enable)}</Label>
            <Togglebox name="mobileValues.hidMobileValues.enabled" label="" cyName="Enabled" />
        </div>

        {/* Identification Mode */}
        <div className="py-2">
            <div className="flex flex-col mb-2">
                <span className="text-md font-bold">{translate.byKey(TranslationKeys.identificationMode)}</span>
                <span className="text-sm text-gray-500">{translate.byKey(TranslationKeys.hidIdentificationModeHint)}</span>
            </div>
            {/* Twist & Go */}
            <div className="flex flex-row">
                <div className="w-2/5">
                    <Field
                        id="twistAndGoCheckbox"
                        name="mobileValues.hidMobileValues.twistAndGo">
                        {({ field }) => {
                            return <CheckboxField
                                compact
                                disabled={!values.mobileValues.hidMobileValues.enabled}
                                option={{ value: "1", label: translate.byKey(TranslationKeys.twistAndGo), isSelected: field.value }}
                                onSelect={(value, option) => { setFieldValue("mobileValues.hidMobileValues.twistAndGo", !field.value) }} />
                        }}
                    </Field>
                </div>
                <div className="flex flex-row p-1">
                    <Field
                        id="twistAndGoRssi"
                        type="number"
                        name="mobileValues.hidMobileValues.twistAndGoRssi"
                        disabled={!values.mobileValues.hidMobileValues.enabled || !values.mobileValues.hidMobileValues.twistAndGo}
                        className={`flex flex-row items-center p-1 px-2 text-gray-800 text-sm w-64 bg-gray-input ${!values.mobileValues.hidMobileValues.enabled || !values.mobileValues.hidMobileValues.twistAndGo ? 'text-gray-500 text-sm bg-gray-input cursor-not-allowed' : ''}`}
                        validate={(value) => validateRssiField(value, translate)} />
                    <div className="flex flex-row justify-between" id='twistAndGoRssiLabel'>
                        {twistAndGoRssiError ? <span className='text-red-600 text-xs pt-2 pl-1'>{twistAndGoRssiError}</span> : null}
                    </div>
                </div>
            </div>

            {/* Tap */}
            <div className="flex flex-row">
                <div className="w-2/5">
                    <Field
                        id="tapCheckbox"
                        name="mobileValues.hidMobileValues.tap"
                        render={({ field }) => {
                            return <CheckboxField
                                compact
                                disabled={!values.mobileValues.hidMobileValues.enabled}
                                option={{ value: "1", label: translate.byKey(TranslationKeys.hidTap), isSelected: field.value }}
                                onSelect={(value, option) => setFieldValue("mobileValues.hidMobileValues.tap", !field.value)} />
                        }}
                    />
                </div>
                <div className="flex flex-row p-1">
                    <Field
                        id="tapRssi"
                        type="number"
                        name="mobileValues.hidMobileValues.tapRssi"
                        disabled={!values.mobileValues.hidMobileValues.enabled || !values.mobileValues.hidMobileValues.tap}
                        className={`flex flex-row items-center p-1 px-2 text-gray-800 text-sm w-64 bg-gray-input ${!values.mobileValues.hidMobileValues.enabled || !values.mobileValues.hidMobileValues.tap ? 'text-gray-500 text-sm bg-gray-input cursor-not-allowed' : ''}`}
                        validate={(value) => validateRssiField(value, translate)} />
                    <div className="flex flex-row justify-between" id='tapRssiLabel'>
                        {tapRssiError ? <span className='text-red-600 text-xs pt-2 pl-1'>{tapRssiError}</span> : null}
                    </div>

                </div>
            </div>

            {/* Remote */}
            <div className="flex flex-row">
                <div className="w-2/5">
                    <Field
                        id="remoteCheckbox"
                        name="mobileValues.hidMobileValues.remote"
                        render={({ field }) => {
                            return <CheckboxField
                                compact
                                disabled={!values.mobileValues.hidMobileValues.enabled}
                                option={{ value: "remoteCheckbox", label: translate.byKey(TranslationKeys.remote), isSelected: field.value }}
                                onSelect={(value, option) => setFieldValue("mobileValues.hidMobileValues.remote", !field.value)} />
                        }}
                    />
                </div>
                <div className="flex flex-row p-1">
                    <Field
                        id="remoteRssi"
                        type="number"
                        name="mobileValues.hidMobileValues.remoteRssi"
                        className={`flex flex-row items-center p-1 px-2 text-gray-800 text-sm w-64 bg-gray-input ${!values.mobileValues.hidMobileValues.enabled || !values.mobileValues.hidMobileValues.remote ? 'text-gray-500 text-sm bg-gray-input cursor-not-allowed' : ''}`}
                        validate={(value) => validateRssiField(value, translate)}
                        disabled={!values.mobileValues.hidMobileValues.enabled || !values.mobileValues.hidMobileValues.remote} />
                    <div className="flex flex-row justify-between" id='remoteRssiLabel'>
                        {remoteRssiError ? <span className='text-red-600 text-xs pt-2 pl-1'>{remoteRssiError}</span> : null}
                    </div>
                </div>
            </div>
            {/* <hr className="w-1/2 mt-2" />
            <div className="-mx-2">
                <Field
                    id="reverseBytes"
                    name="mobileValues.hidMobileValues.reverseBytes"
                    render={({ field }) => {
                        return <CheckboxField
                            compact
                            option={{ value: "1", label: translate.byKey(TranslationKeys.reverseBytesOrderOfPACS), isSelected: field.value }}
                            onSelect={(value, option) => {
                                setFieldValue("mobileValues.hidMobileValues.reverseBytes", !field.value);
                            }} />
                    }} />
            </div> */}
        </div>
    </div>
}

export default HIDPresetMobileTab;